import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-充值流水",
  "use": "icon-充值流水-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-充值流水\">\n<g transform=\"translate(2 2) scale(0.75)\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"0.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n\t<path d=\"M2.4,5.1h9.5c0.8,0,1.4,0.6,1.4,1.4v5.7c0,0.8-0.6,1.4-1.4,1.4H2.4c-0.8,0-1.4-0.6-1.4-1.4V6.5C1,5.7,1.6,5.1,2.4,5.1z\" />\n\t<path d=\"M3.1,5.1l6.5-2.3c0.8-0.3,1.7,0.3,1.7,1.2v1.1\" />\n\t<path d=\"M10.8,9.3h3.6\" />\n\t<path d=\"M12.6,7.5v3.6\" />\n\t<path d=\"M4.3,9.4h3.8\" />\n\t<path d=\"M6.2,7.5v3.8\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/充值流水.svg
// module id = j2qz
// module chunks = 166